
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.353.647c.989.988.806 2.888-.288 4.853 1.094 1.964 1.276 3.865.288 4.853-.988.988-2.888.806-4.853-.288-1.964 1.094-3.865 1.277-4.853.288-.989-.988-.806-2.888.288-4.853C-.159 3.536-.34 1.635.647.647 1.635-.342 3.535-.159 5.5.935l.052-.028c1.946-1.07 3.82-1.24 4.8-.26zM9.5 6.4l-.027.04a12.469 12.469 0 01-1.388 1.646c-.52.52-1.083.995-1.686 1.416 1.444.697 2.719.788 3.305.203.586-.586.495-1.861-.204-3.305zM1.5 6.4l-.007.014C.8 7.853.712 9.122 1.295 9.704c.586.587 1.861.496 3.305-.203a12.42 12.42 0 01-1.686-1.415A12.44 12.44 0 011.5 6.4zM5.5 2.001l-.064.04a11.33 11.33 0 00-1.874 1.522A11.309 11.309 0 002.002 5.5a11.34 11.34 0 001.56 1.938C4.15 8.028 4.8 8.55 5.5 8.998a11.339 11.339 0 001.938-1.56A11.344 11.344 0 008.998 5.5a11.282 11.282 0 00-1.56-1.938A11.32 11.32 0 005.5 2.002zm.564 2.613c.177 0 .322.145.322.322v1.128a.324.324 0 01-.322.322H4.936a.324.324 0 01-.322-.322V4.936c0-.178.144-.321.322-.322h1.128zM1.295 1.295C.71 1.881.8 3.156 1.5 4.6a12.42 12.42 0 011.416-1.685C3.435 2.395 4 1.92 4.602 1.5 3.157.802 1.882.71 1.296 1.297v-.002zm5.12.197l-.015.006c.603.422 1.167.896 1.687 1.416.52.52.994 1.084 1.415 1.687.698-1.445.788-2.72.203-3.306-.583-.584-1.851-.495-3.29.197z","fill":"url(#paint0_linear_332_1347)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_332_1347","x1":"0","y1":"5.5","x2":"11","y2":"5.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#928FE8"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#F8BCCF"}})])])])
          )
        }
      }
    